import { ALL_MONTHS } from "consts";
import { capitalizeString } from "utils";

/**
 * Returns the full list of months for a fiscal year based on the company's fiscal year start and end months.
 *
 * @param companyFiscalYear - An array with two strings representing the start and end months of the fiscal year (e.g. ["Nov", "Oct"]).
 * @param choosenYear - The fiscal year as a number (e.g. 2025 for FY25).
 * @returns An array of obejcts formatted with header: string, year: number like [{header: "Nov '24", year: 2024}, {header: "Dec '24", year: 2024}, ..., {header: "Oct '25", year: 2025}].
 */
export function getFiscalYearMonthHeaders(
  companyFiscalYear: string[],
  choosenYear: number,
): { header: string; year: number }[] {
  const allMonths = [...ALL_MONTHS];
  const startMonth = capitalizeString(companyFiscalYear[0]);
  const endMonth = capitalizeString(companyFiscalYear[1]);
  const startIndex = allMonths.indexOf(startMonth);
  const endIndex = allMonths.indexOf(endMonth);

  // Fiscal year starts in the previous year
  const startYear = choosenYear - 1;
  const shortStartYear = Number(startYear.toString().substring(2));
  const shortEndYear = Number(choosenYear.toString().substring(2));

  if (startIndex === 0 && endIndex === 11) {
    // Case when fiscal year is Jan to Dec (full calendar year)
    return allMonths.map((month) => ({
      header: `${month} '${shortEndYear}`,
      year: choosenYear,
    }));
  }

  const currentYearCalendar = allMonths
    .slice(startIndex)
    .map((month) => ({
      header: `${month} '${shortStartYear}`,
      year: startYear,
    }));
  const nextYearCalendar = allMonths
    .slice(0, endIndex + 1)
    .map((month) => ({
      header: `${month} '${shortEndYear}`,
      year: choosenYear,
    }));

  return [...currentYearCalendar, ...nextYearCalendar];
}
